module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"colorado-state-budget-visualization","short_name":"budget-visualization","start_url":"/","background_color":"#186ea8","theme_color":"#186ea8","display":"minimal-ui","icon":"src/images/cga-logo-med.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
